module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point05_03_sunset-ce4a63a6f62bb325bf9d38c9fc84d23a.jpg";